<script lang="ts">
    /* eslint svelte/no-at-html-tags: "off" */
    import logo_webp from '$assets/logo.webp';
    import logo_png from '$assets/logo.png';
    import Picture from '$components/Picture.svelte';
    import Modal, { createModal } from '$components/Modal.svelte';
    import MultiQuoteForm from './MultiQuoteForm.svelte';
    import { melt } from '@melt-ui/svelte';
    import { cx } from '$lib/utils/cx';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import * as t from '$trans';
    import BBCode from '$components/BBCode/BBCode.svelte';
    import { getContainer } from '$components/Context/ContainerContext';
    import { CountryNull } from '$lib/UrlHelper';

    export let withCategory: boolean = true;
    export let categoryId: number | null = null;
    export let relatedCmsPostId: number | null = null;
    export let country: string | null = null;
    export let html: string | null = null;

    let className = '';
    export { className as class };

    export let defaultClass: string | undefined | null =
        'btn-leo btn-leo-primary btn-xl ls:btn-lg w-full ls:w-auto text-14 px-12 rounded-full items-center font-normal';

    const { lang } = getContainer();

    const modal = createModal({});
    const {
        elements: { trigger, close, title },
    } = modal;
</script>

<button class={cx(className, defaultClass ?? '')} use:melt={$trigger}>
    {#if html != null}
        {@html html}
    {:else}
        <i class="fa fa-fw fa-envelope-o mr-2" />
        <span class="font-bold ls:font-normal">Demande de devis</span>
    {/if}
</button>

<Modal contentClass="w-full t:w-[650px]" dialogClass="b:text-left b:items-start" {modal}>
    <div
        class="bg-brand-blue w-full h-[70px] t:h-[90px] flex justify-center relative p-[15px]"
    >
        <Picture
            webp={logo_webp}
            png={logo_png}
            alt="Logo de Go Africa Online"
            class="h-full w-auto"
        />

        <button
            use:melt={$close}
            type="button"
            class="absolute btn-reset top-[15px] right-[20px] text-22 opacity-100 hover:opacity-50"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="p-[15px]">
        <BBCode
            bbcode={t.multiquote.modal__description_text({}, $lang)}
            country={country ?? CountryNull}
        />

        <h2
            use:melt={$title}
            class="font-bold text-22 text-brand-blue text-center mt-0 mb-8"
        >
            <BBCode
                bbcode={t.multiquote.modal__title({}, $lang)}
                country={country ?? CountryNull}
            />
        </h2>

        <MultiQuoteForm {categoryId} {relatedCmsPostId} {country} {withCategory} let:form>
            <p class="text-gray-600 text-13 mt-4">
                <BBCode bbcode={t.ui.form_data_processing_notice({}, $lang)} />
            </p>

            <div
                class="p-[15px] border-top flex flex-row-reverse gap-[8px] mt-8 flex-wrap"
            >
                <SubmitButton
                    {form}
                    class="btn-leo btn-leo-primary btn-lg whitespace-normal	"
                    text="Envoyer votre demande"
                />

                <button class="btn-leo btn-leo-gray-blue" use:melt={$close}
                    >Fermer
                </button>
            </div>
        </MultiQuoteForm>
    </div>
</Modal>
